import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/basicInfo';
const expertInfo: Array<RouteConfig> = [
    {
        path: 'data-manage/expert-info',
        name: 'expertInfo',
        redirect: { name: 'expertOrganization' },
        meta: {
            menuMatch: 'expertOrganization',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'expert-organization',
                name: 'expertOrganization',
                component: () => import(`@/${BASE_PATH}/Organization.vue`),
                meta: {
                    index: '8-1',
                },
            },
            {
                path: 'expert-personnel',
                name: 'expertPersonnel',
                component: () => import(`@/${BASE_PATH}/personnel/Personnel.vue`),
                meta: {
                    index: '8-2',
                },
            },
            {
                path: 'expert-permissions',
                name: 'expertPermissions',
                component: () => import(`@/${BASE_PATH}/permissions/Permissions.vue`),
                meta: {
                    index: '8-3',
                    subPage:'expertPermissionsDetail'
                },
            },
            {
                path: 'expert-permissions-detail',
                name: 'expertPermissionsDetail',
                component: () => import(`@/${BASE_PATH}/permissions/PermissionsDetail.vue`),
                meta: {
                    index: '8-3',
                    supPage:'expert-permissions'
                },
            },
        ],
    },
];
export default expertInfo;